import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  "xml:space": "preserve",
  viewBox: "0 0 69.8 48"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M5.9 27.2 24 45.4 62.2 9.3",
  style: {"fill":"none","stroke":"#fff","stroke-linecap":"round","stroke-linejoin":"round","stroke-miterlimit":"10"}
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }